import ControlOutlinedIcon from '@mui/icons-material/Tune'
import BookIcon from '@mui/icons-material/MenuBook'
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly'
import LineChartIcon from '@mui/icons-material/ShowChart'
import DashboardIcon from '@mui/icons-material/Dashboard'
import DesktopIcon from '@mui/icons-material/DesktopWindows'
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks'
import DeviceHubIcon from '@mui/icons-material/DeviceHub'

// Permiso → icon, label key, color (MUI palette key for chips/avatars)
export const PERMISSIONS = {
    manager: { icon: ControlOutlinedIcon, labelKey: 'Manager', color: '#d32f2f' },
    inventories: { icon: BookIcon, labelKey: 'Inventories', color: '#2e7d32' },
    controllers: { icon: MobileFriendlyIcon, labelKey: 'Controllers', color: '#f9a825' },
    statistics: { icon: LineChartIcon, labelKey: 'Statistics', color: '#1976d2' },
    capacity: { icon: DashboardIcon, labelKey: 'Capacity', color: '#7b1fa2' },
    // Permiso 'selfcheck' protege ImageSets y SIP Operations (autopréstamo)
    selfcheck: { icon: DesktopIcon, labelKey: 'SelfChecks', color: '#ef6c00' },
    // Permiso 'alarms' sigue igual en BD/código; en UI se muestra como "Book Alerts"
    alarms: { icon: LibraryBooksIcon, labelKey: 'Book Alerts', color: '#0097a7' },
    nodes: { icon: DeviceHubIcon, labelKey: 'Nodes', color: '#5d4037' }
}

export const PERMISSION_KEYS = Object.keys(PERMISSIONS)

export const ROLES = [
    { value: 'user', labelKey: 'User', color: 'default' },
    { value: 'supervisor', labelKey: 'Supervisor', color: 'warning' },
    { value: 'admin', labelKey: 'Administrator', color: 'error' }
]

export const FLAVORS = ['TECHKOVERY', 'DIALOCID', 'LIBTECS']

export const getRoleMeta = (role) => ROLES.find((r) => r.value === role) || ROLES[0]

// Stable color from a string (used for avatar fallback background)
export const colorFromString = (str = '') => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    const palette = [
        '#1976d2',
        '#388e3c',
        '#7b1fa2',
        '#c2185b',
        '#f57c00',
        '#0097a7',
        '#5d4037',
        '#455a64',
        '#d32f2f',
        '#512da8'
    ]
    return palette[Math.abs(hash) % palette.length]
}

export const getInitials = (fullName = '', userName = '') => {
    const source = (fullName || userName || '?').trim()
    const parts = source.split(/\s+/).filter(Boolean)
    if (parts.length === 0) return '?'
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
